var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.28 4.62H16.5V3.18a.18.18 0 0 0-.18-.18h-1.26a.18.18 0 0 0-.18.18v1.44H9.12V3.18A.18.18 0 0 0 8.94 3H7.68a.18.18 0 0 0-.18.18v1.44H3.72a.72.72 0 0 0-.72.72v14.94c0 .398.322.72.72.72h16.56a.72.72 0 0 0 .72-.72V5.34a.72.72 0 0 0-.72-.72m-.9 14.76H4.62v-8.55h14.76zM4.62 9.3V6.24H7.5v1.08c0 .099.081.18.18.18h1.26a.18.18 0 0 0 .18-.18V6.24h5.76v1.08c0 .099.081.18.18.18h1.26a.18.18 0 0 0 .18-.18V6.24h2.88V9.3z"
  })));
};
export default SvgCalendar;